import { useNavigate } from 'react-router-dom';

function StatusBadge({ status }) {
  const map = {
    online:  { color: 'bg-green-500/15 text-green-400 border-green-500/30', dot: 'bg-green-400', label: 'Онлайн' },
    offline: { color: 'bg-slate-500/15 text-slate-400 border-slate-600/40', dot: 'bg-slate-400', label: 'Офлайн' },
    error:   { color: 'bg-red-500/15 text-red-400 border-red-500/30',       dot: 'bg-red-400',   label: 'Ошибка' },
    warning: { color: 'bg-yellow-500/15 text-yellow-400 border-yellow-500/30', dot: 'bg-yellow-400', label: 'Внимание' },
  };
  const s = map[status] || map['offline'];
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border font-medium ${s.color}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}

function StatBlock({ label, value, unit, warn, icon, offline }) {
  return (
    <div className={`flex-1 rounded-xl p-3 ${warn ? 'bg-red-500/10 border border-red-500/20' : 'bg-slate-700/50'}`}>
      <div className="flex items-center gap-1.5 mb-1">
        <span className="text-slate-400 text-xs">{icon}</span>
        <span className="text-slate-400 text-xs">{label}</span>
      </div>
      <div className={`text-2xl font-bold tracking-tight ${warn ? 'text-red-400' : 'text-white'}`}>
        {offline || value === null || value === undefined ? (
          <span className="text-slate-500 text-lg">—</span>
        ) : (
          <>{parseFloat(value).toFixed(2)}<span className="text-sm font-normal text-slate-400 ml-1">{unit}</span></>
        )}
      </div>
    </div>
  );
}

const OFFLINE_MS = 2 * 60 * 1000;

export default function BoilerCard({ boiler }) {
  const navigate = useNavigate();
  const tempWarn = (boiler.temp_max != null && boiler.temperature > boiler.temp_max) ||
    (boiler.temp_min != null && boiler.temperature < boiler.temp_min);
  const pressWarn = (boiler.pressure_max != null && boiler.pressure > boiler.pressure_max) ||
    (boiler.pressure_min != null && boiler.pressure < boiler.pressure_min);
  const isOnline = boiler.last_seen && (Date.now() - new Date(boiler.last_seen).getTime()) < OFFLINE_MS;

  return (
    <div
      onClick={() => navigate(`/boilers/${boiler.id}`)}
      className="bg-slate-800 border border-slate-700/80 hover:border-blue-500/40 rounded-2xl p-4 cursor-pointer transition-all hover:shadow-xl hover:shadow-blue-500/5 active:scale-[0.98] group"
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="min-w-0 flex-1 mr-3">
          <h3 className="font-semibold text-white text-base leading-tight truncate group-hover:text-blue-300 transition-colors">
            {boiler.name}
          </h3>
          {boiler.location && (
            <p className="text-xs text-slate-400 mt-0.5 truncate">{boiler.location}</p>
          )}
          {boiler.owner_name && (
            <p className="text-xs text-blue-400 mt-0.5 truncate">{boiler.owner_name}</p>
          )}
        </div>
        <span className={`inline-flex items-center gap-1.5 text-xs px-2.5 py-1 rounded-full border font-medium ${
          isOnline
            ? 'bg-emerald-500/15 text-emerald-400 border-emerald-500/30'
            : 'bg-slate-500/15 text-slate-400 border-slate-600/40'
        }`}>
          <span className={`w-1.5 h-1.5 rounded-full ${isOnline ? 'bg-emerald-400 animate-pulse' : 'bg-slate-500'}`} />
          {isOnline ? 'Онлайн' : 'Оффлайн'}
        </span>
      </div>

      {/* Stats */}
      <div className="flex gap-2 mb-2">
        <StatBlock
          label="Подача"
          value={boiler.temperature}
          unit="°C"
          warn={tempWarn}
          icon="🌡"
          offline={!isOnline}
        />
        <StatBlock
          label="Обратка"
          value={boiler.temperature2}
          unit="°C"
          icon="🌡"
          offline={!isOnline}
        />
        <StatBlock
          label="Давление"
          value={boiler.pressure}
          unit="бар"
          warn={pressWarn}
          icon="⚡"
          offline={!isOnline}
        />
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between">
        <p className="text-xs text-slate-500">
          {boiler.last_seen
            ? `Обновлено: ${new Date(boiler.last_seen).toLocaleString('ru-RU')}`
            : 'Нет данных'}
        </p>
        <svg className="w-4 h-4 text-slate-600 group-hover:text-blue-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </div>
  );
}
